import(/* webpackMode: "eager" */ "/vercel/path0/src/app/analysis/page.tsx");
